export const clusterList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export const colorList = ['#1783FF', '#00C9C9', '#F08F56', '#D580FF', '#FADC19', '#9FDB1D', '#F7BA1E', '#14C9C9', '#3491FA', '#F5319D', '#165DFF', '#722ED1', '#D91AD9', '#14C9C9', '#3491FA', '#E8FFEA', '#165DFF', '#722ED1', '#D91AD9', '#14C9C9', '#3491FA', '#E8FFEA', '#165DFF', '#722ED1', '#D91AD9', '#14C9C9', '#3491FA', '#E8FFEA', '#165DFF', '#722ED1', '#D91AD9'];

let groupedNodes = {};

/**
 * 生成连接边以保证图的连通性
 * @param {Array} nodes - 节点数组
 * @param {boolean} lightMode - 轻量级模式，减少连线干扰
 * @returns {Array} 边数组
 */
export const generateConnectivityEdges = (nodes, lightMode = false) => {
  const edges = [];

  if (nodes.length <= 1) return edges;

  // 找到主节点（通常是第一个或者有特殊标识的节点）
  const mainNode = nodes.find(node => node.isMain) || nodes[0];

  if (lightMode) {
    // 轻量级模式：星型连接，以主节点为中心
    nodes.forEach(node => {
      if (node.id !== mainNode.id) {
        edges.push({
          source: mainNode.id,
          target: node.id,
          style: {
            stroke: '#E5E5E5',
            lineDash: [2, 2],
            opacity: 0.3,
            lineWidth: 1
          }
        });
      }
    });
  } else {
    // 增强连接模式：更密集的连接
    // 主节点连接所有其他节点
    nodes.forEach(node => {
      if (node.id !== mainNode.id) {
        edges.push({
          source: mainNode.id,
          target: node.id,
          style: {
            stroke: '#D1D5DB',
            lineDash: [3, 3],
            opacity: 0.4,
            lineWidth: 1
          }
        });
      }
    });

    // 同cluster节点间的连接
    const clusterGroups = {};
    nodes.forEach(node => {
      const cluster = node.data?.cluster;
      if (cluster) {
        if (!clusterGroups[cluster]) clusterGroups[cluster] = [];
        clusterGroups[cluster].push(node);
      }
    });

    Object.values(clusterGroups).forEach(group => {
      if (group.length > 1) {
        for (let i = 0; i < group.length - 1; i++) {
          edges.push({
            source: group[i].id,
            target: group[i + 1].id,
            style: {
              stroke: '#F3F4F6',
              lineDash: [1, 1],
              opacity: 0.2,
              lineWidth: 1
            }
          });
        }
      }
    });
  }

  return edges;
};

/**
 * 使用DFS找到连通分量
 * @param {Array} nodes - 节点数组
 * @param {Array} edges - 边数组
 * @returns {Array} 连通分量数组
 */
export const findConnectedComponents = (nodes, edges) => {
  const adjacencyList = {};
  const visited = new Set();
  const components = [];

  // 构建邻接表
  nodes.forEach(node => {
    adjacencyList[node.id] = [];
  });

  edges.forEach(edge => {
    if (adjacencyList[edge.source] && adjacencyList[edge.target]) {
      adjacencyList[edge.source].push(edge.target);
      adjacencyList[edge.target].push(edge.source);
    }
  });

  // DFS遍历
  const dfs = (nodeId, component) => {
    visited.add(nodeId);
    component.push(nodeId);

    adjacencyList[nodeId].forEach(neighborId => {
      if (!visited.has(neighborId)) {
        dfs(neighborId, component);
      }
    });
  };

  // 找到所有连通分量
  nodes.forEach(node => {
    if (!visited.has(node.id)) {
      const component = [];
      dfs(node.id, component);
      components.push(component);
    }
  });

  return components;
};

export const converNodeData = (data) => {
  let nodeData = [];
  let edgeData = [];
  const list = data[0].friend_list[0];
  nodeData.push({
    id: `${data.book_keywords_id}`,
    label: data.keywords,
    data: {
      cluster: 'aaa'
    },
    style: {
      size: 35
    }
  })
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    nodeData.push({
      id: `${item.book_keywords_id}`,
      label: item.keywords,
      data: {
        cluster: clusterList[i]
      },
      style: {
        size: 30
      }
    });
    edgeData.push({
      source: `${data.book_keywords_id}`,
      target: `${item.book_keywords_id}`,
      type: 'line'
    });
    if (item.label_list) {
      for (let j = 0; j < item.label_list.length; j += 1) {
        const labelItem = item.label_list[j];
        const nodeId = `${item.book_keywords_id}${labelItem.id}`;
        nodeData.push({
          id: nodeId,
          label: labelItem.name,
          data: {
            cluster: clusterList[i]
          },
          style: {
            size: 20
          }
        });
        edgeData.push({
          source: `${item.book_keywords_id}`,
          target: nodeId,
          type: 'line'
        });
      }
    }
  }
  return {
    nodeData,
    edgeData
  }
}

const getOtherList = (list, pList) => {
  let nodeData = []
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    const nodeId = `${item.id}`;
    if (!pList.includes(item.name)) {
      nodeData.push({
        id: nodeId,
        label: item.name,
        data: {
          originId: item.id
        }
      });
    }
  }
  return nodeData;
}

const getNodeList = (item, i) => {
  let nodeData = []
  if (item.label_list) {
    for (let j = 0; j < item.label_list.length; j += 1) {
      const labelItem = item.label_list[j];
      const nodeId = `${item.book_keywords_id}${labelItem.id}`;
      nodeData.push({
        id: nodeId,
        label: labelItem.name,
        data: {
          originId: labelItem.id,
          cluster: clusterList[i]
        }
      });
    }
  }
  return nodeData
}


export const getBiData = (data) => {
  let nodeData = [];
  const current = data.keywords_info
  const labelList = data.label_all_list

  // 检查是否有关联数据
  const hasCorrelationData = current.friend_list && current.friend_list.length > 0 && current.friend_list[0].length > 0;

  if (!hasCorrelationData) {
    // 无关联数据的情况：只显示标签节点，不显示主节点
    console.log('无关联数据，创建标签节点显示');

    // 只创建标签节点，不创建主节点
    if (current.label_list && current.label_list.length > 0) {
      current.label_list.forEach((labelItem, index) => {
        nodeData.push({
          id: `tag_${labelItem.id}`,
          label: labelItem.name,
          data: {
            originId: labelItem.id,
            cluster: clusterList[index % clusterList.length]
          },
          style: {
            size: 25
          }
        });
      });
    }

    // 生成连接边保证连通性（如果有多个标签节点的话）
    const edges = nodeData.length > 1 ? generateConnectivityEdges(nodeData, true) : [];

    return {
      nodeData,
      edges,
      intersectionNodes: nodeData,
      uniqueNodeData: []
    };
  }

  // 原有的连通数据处理逻辑
  const list = current.friend_list.flat();
  let currentArr = getNodeList(current, list.length)

  // 为搜索关键词节点添加标识
  if (currentArr.length > 0) {
    currentArr.forEach(node => {
      if (node.label === current.keywords || node.label === data.inputValue) {
        node.isSearchKeyword = true;
      }
    });
  }

  let aa = []
  list.forEach((l) => {
    aa = aa.concat(l.label.split(','))
  })
  let p = new Set([...current?.label?.split(',') || [], ...aa]);
  const pList = Array.from(p);
  nodeData = nodeData.concat(currentArr)
  
  // 添加标签列表中的节点（包括孤立节点），后续会通过cluster属性过滤
  let aaa = getOtherList(labelList, pList);
  nodeData = nodeData.concat(aaa)
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    let arr = getNodeList(item, i)
    nodeData = nodeData.concat(arr)
  }

  // 找出具有相同label的节点
  const intersectionNodes = [];
  const labelMap = new Map();
  const uniqueNodeData = [];  // 新增：存储不重复label的节点
  // 首先按label对节点进行分组
  nodeData.forEach(node => {
    if (node.label) {
      if (!labelMap.has(node.label)) {
        labelMap.set(node.label, []);
        uniqueNodeData.push(node);  // 只添加第一次出现的节点
      }
      labelMap.get(node.label).push(node);
    }
  });

  // 找出具有相同label的节点组
  labelMap.forEach((nodes, label) => {
    if (nodes.length > 1) {
      // 检查是否是搜索关键词，如果是则跳过不创建节点
      const isSearchKeyword = label === current.keywords || label === data.inputValue;

      // 跳过搜索关键词，不创建对应的节点
      if (!isSearchKeyword) {
        intersectionNodes.push({
          label,
          id: `${nodes[0].data.originId}`,
          nodes: nodes,
          isSearchKeyword: false,
          data: {
            originId: nodes[0].data.originId,
            cluster: clusterList[Math.floor(Math.random() * clusterList.length)]
          }
        });
      }
    }
  });
  // 对 uniqueNodeData 进行去重，确保不包含 intersectionNodes 中的节点
  const uniqueLabels = intersectionNodes.map(node => node.label);
  const filteredIntersectionNodes = uniqueNodeData.filter(item => {
    return uniqueLabels.indexOf(item.label) === -1
  });

  // 过滤掉搜索关键词节点和没有cluster的孤立节点（来自getOtherList的节点）
  // 只保留有实际关联关系的节点（有cluster属性的节点）
  const finalFilteredNodes = filteredIntersectionNodes.filter(node => {
    const isSearchKeyword = node.label === current.keywords || node.label === data.inputValue;
    const hasCluster = node.data && node.data.cluster; // 只保留有cluster的节点
    return !isSearchKeyword && hasCluster;
  });

  // 调试信息：打印节点标记情况
  console.log('=== 节点标记调试信息 ===');
  console.log('搜索关键词:', current.keywords, '输入值:', data.inputValue);

  intersectionNodes.forEach(node => {
    console.log(`节点 "${node.label}": isSearchKeyword=${node.isSearchKeyword}`);
  });

  filteredIntersectionNodes.forEach(node => {
    console.log(`唯一节点 "${node.label}": isSearchKeyword=${node.isSearchKeyword}`);
  });

  // 为有关联数据的情况生成边
  const allNodes = [...intersectionNodes, ...finalFilteredNodes];
  const edges = [];

  // 由于我们已经过滤掉了搜索关键词节点，不需要创建以搜索关键词为中心的连接边
  // 如果需要连接边，可以创建简单的连接保证图的连通性
  if (allNodes.length > 1) {
    const connectivityEdges = generateConnectivityEdges(allNodes, true);
    edges.push(...connectivityEdges);
  }

  return {
    nodeData,
    edges,
    intersectionNodes,
    uniqueNodeData: finalFilteredNodes  // 返回过滤后的节点数组
  };
}

export const getComboData = (data) => {
  let nodeData = [];
  let combosData = [];
  const list = data[0].friend_list[0];
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    nodeData.push({
      id: `${item.book_keywords_id}`,
      label: item.keywords,
      combo: clusterList[i],
      style: {
        size: 50
      }
    })
    combosData.push({
      id: clusterList[i],
      data: {
        label: item.keywords,
      },
      style: {
        padding: 40,
        x: 0,
        y: 0,
      }
    })
    if (item.label_list) {
      for (let j = 0; j < item.label_list.length; j += 1) {
        const labelItem = item.label_list[j];
        const nodeId = `${item.book_keywords_id}${labelItem.id}`;
        nodeData.push({
          id: nodeId,
          label: labelItem.name,
          combo: clusterList[i],
          style: {
            size: 50
          }
        });
      }
    }
  }
  return { nodeData, combosData };
}

// 搜索关键词的样式：蓝色背景 + 黑字 + 长方形背景
const createSearchKeywordStyle = (baseColor) => ({
  fill: baseColor,
  stroke: baseColor,
  labelFill: '#000',
  labelPadding: 4,
  labelBackgroundFill: baseColor,
  labelBackgroundRadius: 2, // 长方形效果，较小的圆角
});

// 其他词条的样式：灰色背景 + 白字
const createNormalStyle = (baseColor) => ({
  fill: baseColor,
  stroke: baseColor,
  labelFill: '#fff',
  labelPadding: 2,
  labelBackgroundFill: baseColor,
  labelBackgroundRadius: 5,
});

const groupedNodesByCluster = (acc, node) => {
  const arr = [];
  node.nodes.forEach(item => {
    if (item.data?.cluster === acc) {
      arr.push(item.id);
    } else if (item?.nodes?.length) {
      const idx = item.nodes?.findIndex((child) => child?.data?.cluster === acc)
      if (idx !== -1) {
        arr.push(item.id)
      }
    }
  })
  return arr;
}

const someLabel = (labels, labelList) => {
  for (let item of labelList) {
    if (labels.includes(item.name)) {
      return true
    }
  }
  return false
}

/**
 * 生成气泡集合插件配置
 * @param {Object} data - 包含关键词信息的对象
 * @param {Object} graphData - 图形数据对象
 * @returns {Array} 插件配置数组
 */
export const getPlugins = (data, graphData) => {
  // 初始化插件数组
  const plugins = [];

  // 检查数据完整性
  if (!data || !data.keywords_info || !graphData || !graphData.nodes) {
    console.log('数据不完整，返回空插件');
    return plugins;
  }

  // 获取当前关键词信息
  const current = data.keywords_info;

  // 检查是否有好友列表数据
  const hasFriendList = current.friend_list && current.friend_list.length > 0 && current.friend_list[0].length > 0;
  const hasLabels = current.label_list && current.label_list.length > 0;

  if (hasFriendList) {
    // 标准连通图处理 - 原有逻辑
    const list = current.friend_list.flat();
    const total = list.length;
    const labels = current?.label_list?.map((item) => item.name) || [];
    const group = groupedNodesByCluster(clusterList[total], graphData);

    // 为搜索关键词添加蓝色气泡集合（蓝色背景+黑字+长方形）
    plugins.push({
      key: `bubble-sets-${clusterList[total]}`,
      type: 'bubble-sets',
      members: group,
      labelText: current.keywords,
      ...createSearchKeywordStyle('#00BFFF'), // 搜索关键词：蓝色背景+黑字+长方形
    });

    // 遍历好友列表，为其他关联词条创建灰色气泡集合（灰色背景+白字）
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i];
      // 检查是否有匹配的标签
      if (someLabel(labels, item.label_list)) {
        const groupedNodes = groupedNodesByCluster(clusterList[i], graphData);
        // 如果存在分组节点，则添加气泡集合
        if (groupedNodes.length) {
          plugins.push({
            key: `bubble-sets-${clusterList[i]}`,
            type: 'bubble-sets',
            members: groupedNodes,
            labelText: item.keywords,
            ...createNormalStyle('#999999'), // 其他词条：灰色背景+白字
          });
        }
      }
    }
  } else if (hasLabels) {
    // 不连通图的智能处理
    console.log('处理不连通图的气泡集合');

    // 获取所有节点和边（如果有的话）
    const nodes = graphData.nodes || [];
    const edges = graphData.edges || [];

    // 找到连通分量
    const components = findConnectedComponents(nodes, edges);

    // 为每个连通分量创建气泡集合
    components.forEach((component, index) => {
      if (component.length > 1) { // 只为包含多个节点的分量创建气泡
        // 获取分量中的节点信息
        const componentNodes = nodes.filter(node => component.includes(node.id));
        const hasMainNode = componentNodes.some(node => node.isMain);

        // 确定气泡标签
        let labelText;
        if (hasMainNode) {
          labelText = current.keywords || '主节点';
        } else {
          // 使用分量中节点标签的组合
          const nodeLabels = componentNodes.map(node => node.label).filter(Boolean);
          labelText = nodeLabels.slice(0, 2).join('、') + (nodeLabels.length > 2 ? '等' : '');
        }

        // 判断是否包含搜索关键词
        const isSearchKeywordComponent = hasMainNode || labelText === current.keywords;
        
        plugins.push({
          key: `bubble-sets-component-${index}`,
          type: 'bubble-sets',
          members: component,
          labelText: labelText,
          ...(isSearchKeywordComponent 
            ? createSearchKeywordStyle('#1E40AF') // 搜索关键词：蓝色背景+黑字+长方形
            : createNormalStyle(colorList[index % colorList.length]) // 其他：灰色背景+白字
          ),
        });
      }
    });
  }

  console.log('生成的插件配置:', plugins);
  return plugins;
};


export const toFriendList = (data) => {
  return data.map((item) => {
    const label = Array.from(new Set(item.tag_ids.split(','))).join(',');
    return [
      {
        book_keywords_id: item.keywordsinfo.book_keywords_id,
        keywords: item.keywordsinfo.keywords,
        label,
        label_list: item.tag_list.map((item) => ({
          id: item.mk_tag_id,
          name: item.tag
        }))
      }
    ]
  })
}
export const getLabelList = (data) => {
  // 使用 Map 来去重，以 id 为键
  const uniqueMap = new Map();

  data.forEach((item) => {
    const id = item.tags.mk_tag_id;
    // 只有当 id 不存在时才添加到 Map 中
    if (!uniqueMap.has(id)) {
      uniqueMap.set(id, {
        id: id,
        name: item.tags.tag
      });
    }
  });

  // 将 Map 的值转换为数组
  return Array.from(uniqueMap.values());
}
